import { Navigate } from "react-router-dom";

import Dashboard from "../pages/Dashboard"
//General
import PasswordReset from "../pages/AuthenticationInner/PasswordReset";
import PasswordCreate from "../pages/AuthenticationInner/PasswordCreate";
import LockScreen from "../pages/AuthenticationInner/Lock-Screen";
import TwoStepVerification from "../pages/AuthenticationInner/TwoStepVerification";
import SuccessMessage from "../pages/AuthenticationInner/SuccessMessage";
import Fourzerofour from "../pages/ErrorPages/404";
import Fivehundred from "../pages/ErrorPages/500";
import FourzerofourAlt from "../pages/ErrorPages/404Alt";
import Offline from "../pages/ErrorPages/Offline";
import Signin from "../pages/Authentication/login";
import Logout from "../pages/Authentication/logout";
import UserProfile from "../pages/Authentication/user-profile";
import Register from "../pages/Authentication/register";
import Forgetpassword from "../pages/Authentication/forgetpassword";
import MultiStepForm from "../pages/Authentication/MultiStepForm/MultiStepForm";
import LiveAds_wrap from "../pages/Dashboard/LiveAds_wrap/LiveAds_wrap";
import Ads from "../pages/Dashboard/Ads/Ads";
import BusinessInfo from "../pages/Dashboard/BusinessInfo/BusinessInfo";
import MobileView from "../pages/Dashboard/MobileView/MobileView";
import Notification from "../pages/Components/Notification/Notification";
import Settings from "../pages/Components/Settings/Settings";
import NewAds from "../pages/Dashboard/NewAds/NewAds";
import Transaction from "../pages/Dashboard/Transaction/Transaction";
import Privacy from "../pages/Dashboard/Privacy/Privacy";
import Terms from "../pages/Dashboard/Terms/Terms";
import Contact from "../pages/Dashboard/Contact/Contact";
import Mobile from "../pages/Components/Mobile/Mobile";
import Advertisement from "../pages/Components/Advertisement/Advertisement";
import AdsPage from "../pages/Components/AdsPage/AdsPage";
import ProfileCreation from "../pages/Components/ProfileCreation/ProfileCreation";
import AccountDetails from "../pages/Dashboard/AccountDetails/AccountDetails";
import LiveAds from "../pages/Dashboard/LiveAds/LiveAds";
import BureauShare from "../Common/BureauShare/BureauShare";



const authProtectedRoutes = [

    { path: "/dashboard", component: <Dashboard /> },
    { path: "/", exact: true ,component: <Navigate to="/dashboard" /> },
    { path: "*", component: <Navigate to="/dashboard" /> },

    //General routes
   

    // user profile
    { path: "/user-profile", component: <UserProfile /> },

    // { path: "/", component: <Dashboard /> },
    // works

    { path: "/live-ads" , component: <LiveAds_wrap/>},
    { path: "/live-ads/new-ads" , component: <NewAds/>},
    {path:"/business-info" , component: <BusinessInfo/>},
    {path:"/mobile-view" , component: <MobileView/>},
    {path:"/notifications" , component: <Notification/>},
    {path:"/settings" , component: <Settings/>},
    { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
    {path:"/transactions" , component: <Transaction/>},
    {path:"/mobile" , component: <Mobile/>},
    {path:"/advertisement" , component: <Advertisement/>},
    {path:"/contact" , component: <Contact/>},
    {path:"/profile-creation" , component: <ProfileCreation/>},
    {path:"/profile-creation/:id" , component: <ProfileCreation/>},
    {path:"/profile-details/:id" , component: <ProfileCreation/>},
    {path:"/account-details" , component: <AccountDetails/>},
    {path:"/my-profiles" , component: <LiveAds version="sort_filter" />},
  
];

const publicRoutes = [
    // Authentication
    {path: "/ads" , component: <AdsPage/>},
    { path: "/login", component: <Signin /> },
    { path: "/login/:mode", component: <Signin /> },
    { path: "/logout", component: <Logout /> },
    {path:"/privacy" , component: <Privacy/>},
    {path:"/terms" , component: <Terms/>},
    { path: "/register", component: <Register /> },
    { path: "/forgot-password", component: <Forgetpassword /> },
    {path: "/multi-step-form", component: <MultiStepForm /> },
    { path: "/public/bureau-share", component: <BureauShare/> },



    // Authentication Inner

    // { path: "/auth-signout", component: < /> },
    { path: "/auth-pass-reset", component: <PasswordReset /> },
    { path: "/auth-pass-create", component: <PasswordCreate /> },
    { path: "/auth-lockscreen", component: <LockScreen /> },
    { path: "/auth-two-step", component: <TwoStepVerification /> },
    { path: "/auth-success-msg", component: <SuccessMessage /> },

    // Error
    { path: "/error-404", component: <Fourzerofour /> },
    { path: "/error-500", component: <Fivehundred /> },
    { path: "/error-404-alt", component: <FourzerofourAlt /> },
    { path: "/error-offline", component: <Offline /> },

    // Pages
 
    // { path: "/pages-comingsoon", component: <Offline /> },

    // Auth- Inner 

    { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
    // need to changed after backend update
    { path: "/", exact: true, component: <Navigate to="/dashboard" /> },


]
const openRoutes = [
    { path: "/live-ads/:profileId", component: <Ads/> },
    { path: "/public/live-ads/:profileId", component: <Ads/> },
];

export {openRoutes, publicRoutes, authProtectedRoutes };

